import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { ContentComponent } from './layouts/content/content.component';
import { Full_ROUTES } from './shared/routes/full-layout.routes';
import { CONTENT_ROUTES } from './shared/routes/content-layout.routes';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/teams',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullComponent,
    data: { title: 'full Views' },
    children: Full_ROUTES,
  },
  {
    path: '',
    component: ContentComponent,
    data: { title: 'content Views' },
    children: CONTENT_ROUTES,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
